import "./body.css";
import "./about.css";
import Header from "../components/header";
import Footer from "../components/footer";
import smileImage from "../photos/smile.gif";
import React, { useState, useEffect } from "react";
import { getFirestore, collection, addDoc, Timestamp } from "firebase/firestore";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDMO-NMJlMX-5M4px24r41ZstkhlBEtaeQ",
    authDomain: "good-news-from-josiah.firebaseapp.com",
    projectId: "good-news-from-josiah",
    storageBucket: "good-news-from-josiah.firebasestorage.app",
    messagingSenderId: "156596562213",
    appId: "1:156596562213:web:bf07b494a7d614025a12cc",
    measurementId: "G-5H5CL8C545"
};

const app = initializeApp(firebaseConfig);
const mydb = getFirestore(app);
const analytics = getAnalytics(app);

function Subscribe() {
    useEffect(() => {
        document.title = "Josiah Swanson - Subscribe";
    }, []);
    // Subscription form state
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [isParent, setIsParent] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [fromBibleLegos, setFromBibleLegos] = useState(false);
    const [error, setError] = useState(null);
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                setError("Please enter a valid email address.");
                return;
            }
            await addDoc(collection(mydb, "subscribers"), {
                name: name,
                email: email,
                isParent: isParent,
                fromBibleLegos: fromBibleLegos,
                subscribedAt: Timestamp.now()
            });

            setSubmitted(true);
        } catch (err) {
            console.error("Error adding subscriber:", err);
            setError("There was an error. Please try again later.");
        }
    };
    return (
        <>
            <Header />
            <section className="mainbody">
                <img src={smileImage} alt="Smile!"></img>
                <h2>Subscribe</h2>
                <p>Subscribe for a monthly newsletter full of Biblical encouragement and resources for eternally-minded families, right to your inbox!</p>
                {!submitted ? (
                    <form onSubmit={handleSubmit} style={{ maxWidth: '100%' }}>
                        <input
                            type="text"
                            placeholder="Your Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            style={{ textAlign: "left", paddingLeft: '5%', width: '95%' }}
                        />
                        <input
                            type="email"
                            placeholder="Your Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={{ textAlign: "left", paddingLeft: '5%', width: '95%' }}
                        />
                        <div style={{ width: '100%' }}>
                            <label className="checkboxlabel">
                                Are you a parent?{" "}
                                <input style={{ width: 'auto' }}
                                    type="checkbox"
                                    checked={isParent}
                                    onChange={(e) => setIsParent(e.target.checked)}
                                />
                            </label>
                        </div>
                        <div style={{ width: '100%' }}>
                            <label className="checkboxlabel">
                                Did you come here from @biblelegos?{" "}
                                <input
                                    style={{ width: 'auto' }}
                                    type="checkbox"
                                    checked={fromBibleLegos}
                                    onChange={(e) => setFromBibleLegos(e.target.checked)}
                                />
                            </label>
                        </div>
                        <button type="submit">Subscribe</button>
                        {error && <p style={{ color: "red" }}>{error}</p>}
                    </form>

                ) : (
                    <p>Thank you for subscribing! God bless you.</p>
                )}
            </section>
            <Footer />
        </>
    );
}
export default Subscribe;